import { FC, useState } from "react";
import { css } from "styled-components";
import tw from "twin.macro";

import CancelIcon from "../../../assets/icons/cancel.svg";
import { zIndex } from "../../../styles";
import { IconButton } from "../../atoms/IconButton";

export interface BaseHalfModalProps {
  title: string;
  onDismiss?: () => void;
}

export const BaseHalfModal: FC<BaseHalfModalProps> = ({
  title,
  onDismiss,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
    if (onDismiss) onDismiss();
  };

  return (
    <div
      tw="fixed top-0 w-full h-full max-w-screen-sm bg-[#000] bg-opacity-50 m-auto"
      css={[isOpen ? tw`block` : tw`hidden`, css({ zIndex: zIndex.floating })]}
    >
      <div
        tw="fixed bottom-0 w-full max-h-[80vh] overflow-y-scroll rounded-t-[14px] animate-slide-in-up bg-white m-auto max-w-[640px]"
        css={css({ zIndex: zIndex.force })}
      >
        <div tw="flex justify-between p-5 border-b border-solid border-gray">
          <h5 tw="font-base text-[15px] tracking-[.44px]">{title}</h5>
          <IconButton
            icon={
              <CancelIcon
                onClick={closeModal}
                tw="svg"
                css={css({ transform: "scale(.7)" })}
              />
            }
          />
        </div>
        <div tw="p-5">{children}</div>
      </div>
    </div>
  );
};
